import get from 'lodash/get';
import { hasRole } from '../utils/has-role';
import { parseRedirectUrl } from '../utils/url-utils';
import { APPLICATIONS } from '../app-config';
import envConfig from '../config/config';
import { ROUTES } from '../navigation/routes';
import { oktaAuthJSClient, REDIRECT_STORAGE_KEY } from './okta-config';

export async function revokeTokenAndRedirect(redirectURL, hasFocus = false) {
  const accessToken = await oktaAuthJSClient.tokenManager.get('accessToken');
  if (accessToken) {
    await oktaAuthJSClient.token.revoke(accessToken);
  }
  await oktaAuthJSClient.tokenManager.clear();

  const url = parseRedirectUrl(redirectURL, window.location.origin);
  if (!url) {
    console.error('Invalid URL:', redirectURL);
    return;
  }

  url.searchParams.append('hasFocus', hasFocus);

  window.location = url.href;
}

export async function resetOkta() {
  await attemptCloseOktaSession();
  await oktaAuthJSClient.tokenManager.clear();
  localStorage.clear();
  sessionStorage.clear();
  await revokeTokenAndRedirect(ROUTES.ROOT);
}

async function attemptCloseOktaSession() {
  try {
    await oktaAuthJSClient.session.close();
  } catch (error) {
    // Best-effort; no session or network errors are common. Avoid importing logger here (cycles with okta/index).
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.debug('Okta session.close skipped or failed', error);
    }
  }
}

export function getAppsFromAccessToken(accessToken) {
  const roles = get(accessToken, ['claims', 'sundial_roles'], get(accessToken, ['accessToken', 'sundial_roles'], []));

  return APPLICATIONS.filter((app) => roles.some((role) => hasRole(app.roles, role.split(':')[1])));
}

export function setOrRemoveRedirectUrl(redirect) {
  if (redirect) {
    const redirectUrl = parseRedirectUrl(redirect);
    if (redirectUrl) {
      // Only allow redirects to Tempus domains.
      if (
        envConfig.whitelistedRedirectDomain.some((suffix) => {
          return redirectUrl.hostname.endsWith(suffix);
        })
      ) {
        window.sessionStorage.setItem(REDIRECT_STORAGE_KEY, redirectUrl.href);
      }
    }
  } else {
    // Clear if no redirect
    window.sessionStorage.removeItem(REDIRECT_STORAGE_KEY);
  }
}
